<template>
  <div
    :id="blockId"
    class="element-editor line-editor"
    :style="blockStyle"
  >
    <svg class="w-full h-full absolute top-0 left-0.25">
      <g>
        <!-- line start -->
        <path
          v-if="hasLineStart"
          :d="lineStart"
          style="vector-effect: non-scaling-stroke;"
          :fill="lineColor"
          stroke-linejoin="round"
          stroke-linecap="round"
        ></path>

        <!-- line body -->
        <path
          :d="lineBody"
          fill="transparent"
          :stroke="lineColor"
          :stroke-width="strokeWidth"
          :stroke-dasharray="strokeDashArray"
          stroke-linejoin="round"
          stroke-linecap="round"
        ></path>

        <!-- line end -->
        <path
          v-if="hasLineEnd"
          :d="lineEnd"
          style="vector-effect: non-scaling-stroke;"
          :fill="lineColor"
          stroke-linejoin="round"
          stroke-linecap="round"
        ></path>
      </g>
    </svg>
  </div>
</template>

<script>
// In order to understand SVG path commands, please read this document: https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths

const arrowEnd = (w, h) => {
  return `M ${w} ${h / 2} L ${w - 8} ${h / 2 - 8} L ${w - 8} ${h / 2 + 8} Z`
}

const arrowStart = (w, h) => {
  return `M 0 ${h / 2} L 8 ${h / 2 - 8} L 8 ${h / 2 + 8} Z`
}

const LINE_ENDS = {
  arrow: arrowEnd,
}

const LINE_STARTS = {
  arrow: arrowStart,
}

export default {
  name: 'LineEditor',
  components: {
  },
  props: {
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    blockContent: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    width() {
      return this.blockStyle.width.replace('px', '')
    },
    height() {
      return this.blockStyle.height.replace('px', '')
    },
    hasLineStart() {
      return this.blockContent.lS
    },
    hasLineEnd() {
      return this.blockContent.lE
    },
    lineEnd() {
      if (!this.hasLineEnd) return null
      if (!LINE_ENDS[this.blockContent.lE]) return null
      return LINE_ENDS[this.blockContent.lE](this.width, this.height)
    },
    lineStart() {
      if (!this.hasLineStart) return null
      if (!LINE_STARTS[this.blockContent.lS]) return null
      return LINE_STARTS[this.blockContent.lS](this.width, this.height)
    },
    lineBody() {
      return `M 2 ${this.height / 2} H ${this.width - 2}`
    },
    lineColor() {
      return this.blockContent.lC
    },
    strokeWidth() {
      return this.blockContent.lW
    },
    strokeDashArray() {
      return this.blockContent.lD
    },

  },
  mounted() {
    this.$nextTick(() => { this.$emit('ready') })
  },
}
</script>

<style>

</style>
